import React from 'react';
import { SxProps, Theme, styled } from '@mui/material';
import { TypographyStyles } from '../typography';
import { Spacing2 } from '../spacing';
import { Error } from '../color';

export interface InputLabelProps extends React.PropsWithChildren<
  React.LabelHTMLAttributes<HTMLLabelElement>
> {
  required?: boolean;
  sx?: SxProps<Theme>;
  size?: 'small' | 'medium' | 'large';
}

const StyledLabel = styled('label')<InputLabelProps>(({ size }) => ({
  marginBottom: Spacing2,
  ...(size === 'small' ? TypographyStyles.label3 : TypographyStyles.label2),
}));

const RequiredAsterisk = styled('span')(() => ({
  paddingLeft: Spacing2,
  color: Error.default.main,
}));

export const InputLabel = ({
  children, required, ...props
}: InputLabelProps) => (
  <StyledLabel {...props}>
    {children}

    {required && <RequiredAsterisk>*</RequiredAsterisk>}
  </StyledLabel>
);
